// @flow
import { takeEvery, call, put } from 'redux-saga/effects';

import { getCustomizeLastQuestion } from 'pages/MyAccount/services/api/sale';
import { getCampaign } from 'pages/MyAccount/services/api/campaign';
import { getPurchasedVariants } from 'pages/MyAccount/services/api/carts';
import { getUserAvatar } from 'pages/MyAccount/services/api/account';
import {
  CAMPAIGN,
  receiveCampaign,
  receiveCampaignError,
} from 'pages/MyAccount/services/actions/campaignActions';
import {
  setPrevPurchasedVariants,
  endLoadPrevCart,
} from 'pages/MyAccount/services/actions/cartActions';
import {
  USER,
  fetchUserAvatarSuccess,
  fetchUserAvatarError,
} from 'pages/MyAccount/services/actions/userActions';
import {
  requestCustomizeLastQuestion,
  receiveCustomizeLastQuestion,
  receiveCustomizeLastQuestionError,
} from 'pages/MyAccount/services/actions/customizeActions';
import { fetchSaleData } from './sale';

const { REQUEST_ALL_DATA } = CAMPAIGN;
const SELECT = 'select';
const TWO_WINDOW = 'TWO_WINDOW';
const WINDOW_TWO = 'WINDOW_TWO';
const { FETCH_USER_AVATAR_REQUEST } = USER;

// worker sagas
export function* fetchCampaignData() {
  try {
    const campaignData = yield call(getCampaign);
    yield put(receiveCampaign(campaignData));
    return campaignData;
  } catch {
    yield put(receiveCampaignError());
    return '';
  }
}

function* fetchBaseData(action) {
  const { userRole, flags } = action;
  const campaignData = yield call(fetchCampaignData);
  const { userAccess } = campaignData;
  const isSelectUser = userRole === SELECT;
  const campaignInSecondWindow =
    campaignData &&
    campaignData.windowType === TWO_WINDOW &&
    campaignData.campaignStatus === WINDOW_TWO;

  // get favorites, cart, categories and search terms if campaign is accessible to user
  if (userAccess) yield call(fetchSaleData, flags);

  /* if user is a select member and we are in the second window of a 2 window campaign,
      get the user's previous cart. This is so we can calculate product add-to-cart limits */
  if (isSelectUser && campaignInSecondWindow) {
    // using try catch here so that if this worker SAGA fails, it ends the loading state.
    try {
      const { id, type } = campaignData;
      const purchasedVariants = yield call(getPurchasedVariants, id, type);
      const { variantQuantities } = purchasedVariants;
      yield put(setPrevPurchasedVariants(variantQuantities));
    } catch {
      yield put(endLoadPrevCart());
    }
  }
}

export function* fetchUserAvatar() {
  try {
    const data = yield call(getUserAvatar);
    yield put(fetchUserAvatarSuccess(data && data.userAvatarUrl));
  } catch (error) {
    yield put(fetchUserAvatarError(error));
  }
}
export function* fetchCustomizeLastQuestion() {
  try {
    yield put(requestCustomizeLastQuestion());
    const data = yield call(getCustomizeLastQuestion);
    yield put(receiveCustomizeLastQuestion(data.id, data.experimentInfo));
  } catch (error) {
    yield put(receiveCustomizeLastQuestionError(error));
  }
}

// watcher sagas
export function* watchFetchBaseData() {
  yield takeEvery(REQUEST_ALL_DATA, fetchBaseData);
  yield takeEvery(FETCH_USER_AVATAR_REQUEST, fetchUserAvatar);
}
